import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@core/store/store';
import { login } from '@core/auth/store/authSlice';
import { useAuth } from '@core/auth/hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import type { Location } from 'react-router-dom';

type LoginLocationState = {
  from?: Location;
};

export const LoginPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // This app uses Keycloak-hosted login. If a user navigates to `/login`,
  // immediately redirect them to Keycloak instead of showing a local login UI.
  useEffect(() => {
    if (!isAuthenticated) {
      void dispatch(login());
    }
  }, [dispatch, isAuthenticated]);

  if (isAuthenticated) {
    // If user was trying to access a specific page, redirect there.
    // Otherwise, redirect to "/" which triggers SmartRedirect to the first accessible module.
    const from = (location.state as LoginLocationState | null | undefined)?.from?.pathname ?? '/';
    return <Navigate to={from} replace />;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Redirecting to Keycloak…
        </Typography>
        {isLoading ? null : null}
      </Box>
    </Box>
  );
};
